import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { ApiContext } from '../ApiContext/ApiContext';
import axiosClient from '../axiosClient';
import { IBuyerSignUpData, IBuyerSignUpErrors } from './signUpBuyer.types';
import { ISignUpCustomer, ISignUpRequestListing } from './signUp.types';

const submitBuyerSignUp = (signUpData: IBuyerSignUpData, apiUrl: string) => {
  const customerData: ISignUpCustomer = {
    firstName: signUpData.firstName,
    lastName: signUpData.lastName,
    email: signUpData.email,
    phoneNumber: signUpData.phoneNumber,
    companyName: signUpData.companyName,
    whatsappConsent: signUpData.whatsappConsent,
  };

  const requestData: ISignUpRequestListing = {
    metalType: signUpData.metalType,
    quantity: signUpData.quantity,
    productDescription: signUpData.productDescription,
  };

  const customerRequestData = {
    user: customerData,
    request: requestData,
  };

  return axiosClient.post(
    `${apiUrl}/accounts/user/sign-up/buyer/`,
    customerRequestData,
  );
};

const useSignUpBuyer = () => {
  const { apiUrl } = useContext(ApiContext);
  return useMutation<
    AxiosResponse<IBuyerSignUpData>,
    AxiosError<IBuyerSignUpErrors>,
    IBuyerSignUpData
  >({
    mutationFn: (signUpData: IBuyerSignUpData) =>
      submitBuyerSignUp(signUpData, apiUrl),
  });
};

export default useSignUpBuyer;
